import { Box, BoxProps, HStack, Text } from '@chakra-ui/react'
import { ObjectContentNode } from '@helo/cms'

import { Skeleton } from '../../components/SkeletonLoader'
import { ConditionalTooltip } from '../../components/Tooltip/Tooltip'
import { TagDataType } from './tag.types'
import { TAG_LAYOUT, TagLayout } from './tagLayout'

export const tagToString = (value: TagDataType['value']) =>
  typeof value === 'string' ? value : `${value?.tagName}: ${value?.tagValue}`

const defaultOptions: TagDataType['options'] = {}

export const TagRenderer = ({
  contentNode,
  isLoading,
  ...props
}: {
  isLoading?: boolean
  contentNode: ObjectContentNode
} & BoxProps) => {
  // const mergedOptions = merge({}, defaultOptions, config.state)
  const { size, _tooltip, hideLabel, styles } = contentNode.state ?? {}

  const valueSizeStyles = TagLayout.sizeStyles(size)
  const showSkeleton = !!isLoading

  const customStyles = styles && typeof styles === 'object' ? styles : {}

  return (
    <ConditionalTooltip isDisabled={showSkeleton} tooltipOptions={_tooltip}>
      <Skeleton
        isLoading={showSkeleton}
        w={valueSizeStyles.skeletonWidth}
        h={TagLayout.skeletonHeight(valueSizeStyles.fontSize)}
        rounded={TAG_LAYOUT.rounded}
      >
        <Box
          bg="presets.neutral.10"
          px={TAG_LAYOUT.paddingX}
          py={TAG_LAYOUT.paddingY}
          rounded={TAG_LAYOUT.rounded}
          {...props}
          {...customStyles}
        >
          <HStack gap="1" alignItems="center">
            {!hideLabel && (
              <Text
                size={size}
                fontWeight="500"
                whiteSpace="nowrap"
              >{`${(contentNode.data as any)?.tagName}: `}</Text>
            )}
            <Text size={size} fontWeight="600" whiteSpace="nowrap">
              {(contentNode.data as any)?.tagValue}
            </Text>
          </HStack>
        </Box>
      </Skeleton>
    </ConditionalTooltip>
  )
}
